<template>
    <div class="d-flex flex-wrap gc-2 gr-2">
        <div v-if="info.vehicleCategory" class="text-center">
            <v-chip :size="xSmall ? 'x-small' : small ? 'small' : null">
                {{ info.vehicleCategory }}
            </v-chip>
        </div>
        <div v-if="info.vehicleClass" class="text-center">
            <v-chip :size="xSmall ? 'x-small' : small ? 'small' : null">
                {{ info.vehicleClass }}
            </v-chip>
        </div>
        <div v-if="info.transmissionType" class="text-center">
            <v-chip :size="xSmall ? 'x-small' : small ? 'small' : null">
                {{ info.transmissionType }}
            </v-chip>
        </div>
        <div v-if="info.fuelType && info.fuelType !== 'UNSPECIFIED'" class="text-center">
            <v-chip :size="xSmall ? 'x-small' : small ? 'small' : null">
                {{ info.fuelType }}
            </v-chip>
        </div>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class CarFeatureLabels extends Vue {
        @Prop({default: () => ({}), type: Object, required: true}) info
        @Prop({default: () => false, type: Boolean}) small
        @Prop({default: () => false, type: Boolean}) xSmall
    }

    export default CarFeatureLabels
</script>
